import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dateFormatter, dropdownFetch, getCurrentDateTime, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from 'react-router-dom';
import { IPDSearchHandlerBillManagement } from './utils/IPDSearchHandlerBillManagement';
import axios from 'axios';
import { Discount } from '@mui/icons-material';

const IPD_SERVICE_HEADER1 = [
  {
    header: ' Date',
    accessor: (row) => dateFormatter(row?.billingDate)
  },

  {
    header: 'Old Service Name',
    accessor: 'service_name'
  },
  {
    header: 'QTY',
    accessor: 'quantity'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Amount',
    accessor: 'amount'
  },
  {
    header: 'Discount',
    accessor: 'disc_amt'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Bill No',
    accessor: 'bill_no'
  }
];

const IPD_SERVICE_HEADER2 = [
  {
    header: ' Date',
    accessor: (row) => dateFormatter(row?.billingDate)
  },

  {
    header: 'New Service Name',
    accessor: 'service_name'
  },
  {
    header: 'QTY',
    accessor: 'quantity'
  },
  {
    header: 'New Rate',
    accessor: 'rate'
  },
  {
    header: 'New Amount',
    accessor: 'amount'
  },
  {
    header: 'Discount',
    accessor: 'disc_amt'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Bill No',
    accessor: 'bill_no'
  }
];

const LAB_SERVICE_HEADER1 = [
  {
    header: 'Date',
    accessor: 'date'
  },
  {
    header: 'Old Service Name',
    accessor: 'service_name'
  },
  {
    header: 'QTY',
    accessor: (row) => row?.quantity || 1
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Amount',
    accessor: 'amount'
  },
  {
    header: 'Discount',
    accessor: 'disc_amt'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Bill No',
    accessor: 'bill_no'
  }
];

const LAB_SERVICE_HEADER2 = [
  {
    header: 'Date',
    accessor: 'date'
  },
  {
    header: 'New Service Name',
    accessor: 'service_name'
  },
  {
    header: 'QTY',
    accessor: 'quantity'
  },
  {
    header: 'New Rate',
    accessor: 'rate'
  },
  {
    header: 'New Amount',
    accessor: 'amount'
  },
  {
    header: 'Discount',
    accessor: 'disc_amt'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Bill No',
    accessor: 'bill_no'
  }
];

const initialChangeSponsorDataObj = {
  data: [],
  loading: false
};

export const ChangeIpdSponsor = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [changeSponsorObj, setChangeSponsorObj] = useState(initialChangeSponsorDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [iPDSearchDialogOpen, setIPDSearchDialogOpen] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [patientDataList, setPatientDataList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [sponsordropdown, setSponsorDropdown] = useState([]);
  const [groupDetailList, setGroupDetailList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [serviceIds, setServiceIds] = useState([]);
  const [serviceIdsData, setServiceIdsData] = useState([]);
  const [labIdsData, setLabIdsData] = useState([]);

  const [ipdNo, setIpdNo] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getCurrentDateTime('date'),
      time: getCurrentDateTime('time')
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;
  const New_Sponsor = watch('new_sponsor');
  const formSubmit = async (formValues) => {
    setLoading(true);
    const mergedArray = [...serviceIdsData, ...labIdsData];
    console.log(formValues, mergedArray);
    const response = await axios.put(
      `${BASE_URL}/ipd-billing/SponserChange/${formValues.ipd_no}/${formValues.uhid}/${New_Sponsor}`,
      mergedArray
    );
    console.log(response);
    if (response?.status === 201) {
      toast(`${response.data.message}`, { variant: 'warning' });
    } else if (response?.status === 200) {
      toast(`${response.data.message}`, { variant: 'success' });
    } else {
      toast(`Failed to  Sponsor Changed`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleActiveTab = (...args) => {
    setActiveTab(args[0]);
  };

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    setSponsorDropdown(data);
  }, []);

  useEffect(() => {
    getSponsorDropdown();
  }, [getSponsorDropdown]);

  const searchIPDRegisterationDetails = async (ipdNo) => {
    setLoading(true);
    const response = await request('/indoor-registeration-detail', {
      method: 'GET',
      params: ipdNo
    });
    if (response?.success) {
      const { data } = response;
      console.log('HELLLO THE DATA IS HERE', data);
      if (!data) {
        toast('No patient found', { variant: 'warning' });
      } else {
        const serviceData = [];
        const { indoorService } = data;

        indoorService.forEach(({ service_items, bill_no }) =>
          service_items
            .filter((service) => service.service_status === 'active')
            .forEach((service) => {
              serviceIds.push(service.service);
              serviceData.push({
                ...service,
                bill_no
              });
            })
        );
        setServiceList(serviceData);
        setIpdNo(data?.ipd_no);
        setValue('uhid', data?.uhid);
        setValue('current_sponsor', data?.patient?.sponsor?._id);
        setValue('ipd_no', data?.ipd_no);
        setValue('patient_name', `${data?.patient?.first_name} ${data?.patient?.last_name}`);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  const currentSponsor = watch('current_sponsor');
  const selectedSponser = watch('new_sponsor');
  const filteredSponsorOptions = sponsordropdown.filter((data) => data?._id !== currentSponsor);

  const getServiceDataById = useCallback(async () => {
    setIsLoading(true);
    try {
      if (!selectedSponser) {
        console.error('No sponsor selected.');
        return;
      }
      const response = await axios.post(
        `${BASE_URL}/price-list-master/listByServiceIds?sponsorName=${selectedSponser}`,
        { serviceIds: serviceIds }
      );
      const { data: newData } = response.data;
      const updatedServiceList = serviceList
        .map((service) => {
          // Create a copy of each service object to avoid direct mutation of the original serviceList
          const serviceCopy = { ...service };

          // Log the entire service to understand its structure
          console.log(serviceCopy, 'service');

          // Find the matching service in newData based on the correct identifier 'service.service'
          const matchingService = newData.find((newService) => {
            // Log the input values and check if they contain the 'service' field
            console.log(newService.inputValues, 'newService.inputValues');

            return newService.inputValues.some((input) => {
              console.log(input, 'input'); // Log input object for better debugging
              console.log(input.service, 'input.service'); // Log the value of 'input.service'

              // Ensure input.service exists and compare it with service.service
              return input.service && input.service === service.service; // Safeguard with 'input.service'
            });
          });

          // Log the matching service to debug
          console.log(matchingService, 'matchingService');

          // If a match is found, keep the service, otherwise remove it from the service list
          if (matchingService) {
            // Extract the Ipd Charge (ensure it's a float)
            const newRate = parseFloat(matchingService.inputValues[0]['Ipd Charge']);
            console.log(newRate);

            // Update the rate (or use IpdCharge from the service if no new rate)
            serviceCopy.rate = newRate || parseFloat(serviceCopy.IpdCharge);

            // Calculate Discount_per (ensure proper float conversion)
            const Discount_per = parseFloat((serviceCopy.disc_amt * 100) / serviceCopy.amount);

            // Calculate amount (ensure it's a float)
            const amount = parseFloat(newRate * serviceCopy.quantity);
            serviceCopy.amount = amount;

            // Calculate Discount_amt (ensure proper float conversion)
            const Discount_amt = parseFloat((amount * Discount_per) / 100);

            // Calculate netAmount (ensure it's a float)
            const netAmount = parseFloat(amount - Discount_amt);

            // Update the service copy fields with calculated values
            serviceCopy.disc_amt = Discount_amt;
            serviceCopy.net_amt = netAmount;

            return serviceCopy; // Return the updated service copy
          }

          // If no match, return null or remove the service from updatedServiceList
          return null;
        })
        .filter((service) => service !== null); // Filter out null values (services with no match)

      // Filter out any null values

      console.log(newData, 'newData');

      console.log(serviceList, 'serviceList');
      setServiceIdsData(updatedServiceList);
    } catch (error) {
      console.error('Error fetching service data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [selectedSponser]);

  const getLabDataById = useCallback(async () => {
    setIsLoading(true);
    try {
      if (!selectedSponser) {
        console.error('No sponsor selected.');
        return;
      }
      const response = await axios.post(
        `${BASE_URL}/lab-price-list-master/listByLabIds?sponsorName=${selectedSponser}`,
        { serviceIds: serviceIds }
      );
      const { data: newData } = response.data;
      console.log(newData, 'lab new data');
      const updatedServiceList = serviceList
        .map((service) => {
          // Create a copy of each service object to avoid direct mutation of the original serviceList
          const serviceCopy = { ...service };

          // Log the entire service to understand its structure
          console.log(serviceCopy, 'service');

          // Find the matching service in newData based on the correct identifier 'service.service'
          const matchingService = newData.find((newService) => {
            // Log the input values and check if they contain the 'service' field
            console.log(newService.inputValues, 'newService.inputValues');

            return newService.inputValues.some((input) => {
              console.log(input, 'input'); // Log input object for better debugging
              console.log(input.service, 'input.service'); // Log the value of 'input.service'

              // Ensure input.service exists and compare it with service.service
              return input.test && input.test === service.service; // Safeguard with 'input.service'
            });
          });

          // Log the matching service to debug
          console.log(matchingService, 'matchingService');

          // If a match is found, keep the service, otherwise remove it from the service list
          if (matchingService) {
            // Extract the Ipd Charge (ensure it's a float)
            const newRate = parseFloat(matchingService.inputValues[0]['Ipd Charge']);
            console.log(newRate);

            // Update the rate (or use IpdCharge from the service if no new rate)
            serviceCopy.rate = newRate || parseFloat(serviceCopy.IpdCharge);

            // Calculate Discount_per (ensure proper float conversion)
            const Discount_per = parseFloat((serviceCopy.disc_amt * 100) / serviceCopy.amount);

            // Calculate amount (ensure it's a float)
            const amount = parseFloat(newRate * serviceCopy.quantity);
            serviceCopy.amount = amount;

            // Calculate Discount_amt (ensure proper float conversion)
            const Discount_amt = parseFloat((amount * Discount_per) / 100);

            // Calculate netAmount (ensure it's a float)
            const netAmount = parseFloat(amount - Discount_amt);

            // Update the service copy fields with calculated values
            serviceCopy.disc_amt = Discount_amt;
            serviceCopy.net_amt = netAmount;

            return serviceCopy; // Return the updated service copy
          }

          // If no match, return null or remove the service from updatedServiceList
          return null;
        })
        .filter((service) => service !== null); // Filter out null values (services with no match)

      setLabIdsData(updatedServiceList);
    } catch (error) {
      console.error('Error fetching service data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [selectedSponser]);

  useEffect(() => {
    getServiceDataById();
    getLabDataById();
  }, [selectedSponser]);

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Ipd Sponsor Change
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button variant="contained" type="submit">
                  Apply
                </Button>

                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Grid container spacing={2}>
              <Grid item xs={5} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Ipd No./Uhid No.</Typography>
                  <TextField sx={{ flex: 0.4 }} disabled name="ipd_no" placeholder="Adm No." />
                  <Button
                    sx={{ flex: 0.1, minWidth: 0, p: 0.15, height: '100%' }}
                    variant="contained"
                    onClick={() => setIPDSearchDialogOpen(true)}
                  >
                    <SearchIcon />
                  </Button>
                  <TextField disabled sx={{ flex: 0.3 }} name="uhid" placeholder="Uhid No." />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Current Sponsor</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    placeholder="Current Sponsor"
                    name="current_sponsor"
                    menus={sponsordropdown.map((data) => ({ ...data, name: data?.name }))}
                    disabled
                  />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                  <TextField sx={{ flex: 0.8 }} placeholder="Remarks" name="remarks" />
                </Stack>
              </Grid>
              <Grid item xs={5} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                  <TextField sx={{ flex: 0.8 }} name="patient_name" placeholder="Patient Name" disabled />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>New Sponsor</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    placeholder="New Sponsor"
                    name="new_sponsor"
                    menus={filteredSponsorOptions.map((data) => ({ ...data, name: data?.name }))}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={() => handleActiveTab(0)}
                  sx={{
                    my: 0,
                    marginTop: '0.5%',
                    marginBottom: '0.1%',
                    mx: 1,
                    borderRadius: '4px',
                    fontWeight: 700
                  }}
                >
                  Ipd Service
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleActiveTab(1)}
                  sx={{
                    my: 0,
                    marginTop: '0.5%',
                    marginBottom: '0.1%',
                    mx: 1,
                    borderRadius: '4px',
                    fontWeight: 700
                  }}
                >
                  Lab
                </Button>
              </Grid>

              {activeTab === 0 && (
                <>
                  <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.6 }}>
                    <Table
                      containerSX={{ flex: 0.5 }}
                      data={
                        serviceList.filter((item) => item.type === 'S' || item.type === 'Pc' || item.type === 'R') || []
                      }
                      columns={IPD_SERVICE_HEADER1}
                      size="small"
                    />
                    <Table
                      containerSX={{ flex: 0.5 }}
                      data={serviceIdsData || []}
                      columns={IPD_SERVICE_HEADER2}
                      size="small"
                    />
                  </Grid>
                </>
              )}
              {activeTab === 1 && (
                <>
                  <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.5 }}>
                    <Table
                      containerSX={{ flex: 0.5 }}
                      data={serviceList.filter((item) => item.type === 'L') || []}
                      columns={LAB_SERVICE_HEADER1}
                      size="small"
                    />
                    <Table
                      containerSX={{ flex: 0.5 }}
                      data={labIdsData || []}
                      columns={LAB_SERVICE_HEADER2}
                      size="small"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        PaperProps={{ sx: { p: 1 } }}
        open={iPDSearchDialogOpen}
        onClose={() => setIPDSearchDialogOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IPDSearchHandlerBillManagement
          onClose={() => setIPDSearchDialogOpen(false)}
          onAdd={searchIPDRegisterationDetails}
        />
      </Dialog>
    </>
  );
};
